import SelectRoleComponent from 'src/components/ui/select-role/SelectRole';
import { RoleTypeEnum } from 'src/enums/roleTypeEnum';
import { SelectRole } from 'src/types/ViewModel/SelectRole';
import SelectVesselComponent from 'src/components/ui/select-vessel/SelectVessel';
import { SelectOption } from 'src/types/ViewModel/SelectOption';
import { Vessel } from 'src/types/ViewModel/Vessel/Vessel';
import useGetRole from 'src/api/useGetRole';
import { useVesselStore } from '../../../context/VesselContext';
import { useAuthStore } from '../../../context/AuthContext';
import { Role } from 'src/types/ViewModel/Role';
import { useNavigate } from 'react-router-dom';
import { Wrapper } from './UserRoleSelection.styles';

export const UserRoleSelectionComponent: React.FC = () => {
    const { isWriter, canEditGlobally } = useGetRole();
    const { loggedInRole, loggedInUser, setRole, role } = useAuthStore();
    const { selectedVessel, vesselList, setFilteredVesselList, includeInactiveVessels } = useVesselStore();
    const navigate = useNavigate();

    const roleList: RoleTypeEnum[] = [
        RoleTypeEnum.Admin,
        RoleTypeEnum.ExternalUser,
        RoleTypeEnum.FleetPerformanceAnalyst,
        RoleTypeEnum.OtherOdfjellUser,
        RoleTypeEnum.PortOperator,
        RoleTypeEnum.ShipOperator,
        RoleTypeEnum.ShipUser,
        RoleTypeEnum.Unknown,
    ];

    const handleSelectRoleChange = (role: SelectRole) => {
        localStorage.setItem('selectedRole', role.value);
        setRole(new Role(role.value, isWriter([role.value]), canEditGlobally([role.value])));
        if (role.value !== RoleTypeEnum.ShipUser) {
            if (includeInactiveVessels) {
                setFilteredVesselList(vesselList);
            } else {
                setFilteredVesselList(vesselList.filter((o) => o.isActive));
            }
        }
    };

    const getVesselList = (): Vessel[] => {
        return includeInactiveVessels ? vesselList : vesselList.filter((o) => o.isActive);
    };

    const handleSelectVesselChange = (e: SelectOption) => {
        const selVessel = vesselList.find((v) => v.imoNumber === +e.value);
        if (selVessel) {
            updateQuery(selVessel);
            setFilteredVesselList([selVessel]);
        }
    };

    const updateQuery = (vessel: Vessel) => {
        const params = new URLSearchParams({ imoNumber: vessel.imoNumber.toString() });
        if (loggedInUser?.appAccessToken) {
            params.set('appAccessToken', loggedInUser.appAccessToken);
        }
        navigate({
            pathname: '/report-events',
            search: '?' + params.toString(),
        });
    };

    return (
        <>
            {loggedInRole?.roleType === RoleTypeEnum.Admin && (
                <>
                    <h4>Selected role</h4>
                    <Wrapper>
                        <SelectRoleComponent onChange={handleSelectRoleChange} selectedRole={role?.roleType} roleList={roleList} />
                        {role?.roleType === RoleTypeEnum.ShipUser && (
                            <>
                                <SelectVesselComponent
                                    onChange={handleSelectVesselChange}
                                    vesselList={getVesselList()}
                                    selectedVessel={selectedVessel}
                                    width="200px"
                                />
                            </>
                        )}
                    </Wrapper>
                </>
            )}
        </>
    );
};
export default UserRoleSelectionComponent;
